import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/product_return_applications',
  component: Management,
  redirect: '/product_return_applications/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/product_return_applications/List'),
      meta: {
        auth: Auth.listProductReturnApplications
      },
      redirect: '/product_return_applications/list/all',
      children: [
        {
          path: 'all',
          component: () => import('@/views/product_return_applications/ListTable'),
          meta: {
            auth: Auth.listProductReturnApplications,
            tabName: 'all'
          }
        }
      ]
    },
    // 详情
    {
      path: ':id',
      component: () => import('@/views/product_return_applications/DetailLayout'),
      meta: {
        auth: Auth.showProductReturnApplication
      },
      children: [
        // 基本信息
        {
          path: 'detail',
          component: () => import('@/views/product_return_applications/details/Detail'),
          meta: {
            tabName: 'detail', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showProductReturnApplication
          }
        }
      ]
    }
  ]
}
